// Copy for the P2.1 cinematic homepage (all 5 languages).
// Club / Academy teasers reuse the existing approved texts from translations.js.
export const GOOGLE_PROFILE_URL = "https://share.google/mRu6AvGUNy8ahqTLJ";

const COPY = {
  de: {
    chapters: ["Einführung", "Das Erlebnis", "Das Handwerk", "Die Verwandlung", "Leistungen", "Arbeiten", "Vertrauen", "Club", "Akademie", "Kontakt"],
    hero: {
      tagline: "Premium Detailing. Direkt bei Ihnen.",
      copy: "Mobile Fahrzeugaufbereitung und professionelle Polsterreinigung — wir kommen mit Ausrüstung, Wasser und Erfahrung zu Ihnen nach Hause oder ins Büro. In Euskirchen, Bonn, Köln und Umgebung.",
      ctaPrice: "Preis anfragen", ctaWhatsapp: "WhatsApp kontaktieren", scroll: "Entdecken",
    },
    experience: {
      title: "Wir kommen zu Ihnen.",
      text: "Sie übergeben den Schlüssel — wir übernehmen den Rest. Unser mobiles Studio arbeitet direkt vor Ihrer Tür, während Sie Ihren Tag ganz normal fortsetzen.",
      points: ["Termin nach Ihrem Kalender", "Komplette Ausrüstung vor Ort", "Kein Weg zur Werkstatt"],
    },
    craft: {
      title: "Präzision in jedem Detail.",
      text: "Weiche Pinsel, abgestimmte Reinigungsmittel und Mikrofasertücher für jede Oberfläche. Wir arbeiten Fläche für Fläche — sorgfältig, materialschonend und mit Blick für die Details, die andere übersehen.",
      points: ["Materialgerechte Reinigungsmittel", "Pinsel und Mikrofaser für empfindliche Flächen", "Sorgfältige Endkontrolle"],
    },
    transformation: {
      title: "Ein Ergebnis, das man sieht.",
      text: "Gepflegter Lack, frischer Innenraum, klare Linien. So soll sich Ihr Fahrzeug wieder anfühlen — wie am ersten Tag, nur gepflegter.",
      note: "Szenen aus dem PUREGLOSS Markenfilm. Echte Kundenarbeiten finden Sie im Kapitel Arbeiten.",
    },
    services: {
      title: "Unsere Leistungen",
      intro: "Jedes Fahrzeug und jedes Möbelstück ist anders. Senden Sie uns Fotos — wir erstellen Ihnen ein persönliches Angebot.",
      items: [
        { key: "interior", title: "Innenreinigung", desc: "Gründliche Reinigung von Sitzen, Teppichen, Kunststoffen und Scheiben — schonend für Leder, Stoff und Alcantara." },
        { key: "exterior", title: "Außenpflege", desc: "Schonende Handwäsche, Felgen- und Lackpflege für einen gepflegten Glanz." },
        { key: "complete", title: "Komplettaufbereitung", desc: "Innen und außen in einem Termin — für Fahrzeuge, die rundum gepflegt sein sollen." },
        { key: "sofa", title: "Sofa- & Polsterreinigung", desc: "Tiefenreinigung von Sofas, Matratzen und Polstermöbeln bei Ihnen zu Hause. Das Ergebnis hängt von Material und Art der Verschmutzung ab." },
      ],
      cta: "Preis anfragen", concept: "Symbolbild", film: "Markenfilm",
    },
    portfolio: { title: "Echte Arbeiten. Echte Ergebnisse.", text: "Vorher und nachher — Fotos aus unseren Aufträgen.", cta: "Alle Arbeiten ansehen", real: "Echte Kundenarbeit" },
    trust: { title: "Unabhängige Bewertungen auf Google.", text: "Lesen Sie unabhängige Bewertungen unserer Kunden direkt auf Google.", cta: "Bewertungen auf Google lesen" },
    club: { cta: "Club beitreten" },
    academy: { cta: "Akademie entdecken" },
  },
  ua: {
    chapters: ["Вступ", "Досвід", "Майстерність", "Перетворення", "Послуги", "Роботи", "Довіра", "Клуб", "Академія", "Контакт"],
    hero: {
      tagline: "Преміум детейлінг. Просто у вас.",
      copy: "Мобільний детейлінг авто та професійна хімчистка м'яких меблів — ми приїжджаємо з обладнанням, водою та досвідом до вас додому чи в офіс. Euskirchen, Bonn, Köln та околиці.",
      ctaPrice: "Дізнатись ціну", ctaWhatsapp: "Написати у WhatsApp", scroll: "Далі",
    },
    experience: {
      title: "Ми приїжджаємо до вас.",
      text: "Ви передаєте ключі — ми беремо решту на себе. Наша мобільна студія працює просто біля вашого дому, поки ви займаєтесь своїми справами.",
      points: ["Час за вашим графіком", "Все обладнання на місці", "Без поїздок на мийку"],
    },
    craft: {
      title: "Точність у кожній деталі.",
      text: "М'які щітки, підібрані засоби та мікрофібра для кожної поверхні. Ми працюємо крок за кроком — уважно, дбайливо до матеріалів і до деталей, які інші не помічають.",
      points: ["Засоби відповідно до матеріалу", "Щітки та мікрофібра для делікатних поверхонь", "Ретельна фінальна перевірка"],
    },
    transformation: {
      title: "Результат, який видно.",
      text: "Доглянутий лак, свіжий салон, чисті лінії. Таким ваше авто має відчуватись знову — як у перший день, тільки доглянутіше.",
      note: "Кадри з бренд-фільму PUREGLOSS. Реальні роботи для клієнтів — у розділі «Роботи».",
    },
    services: {
      title: "Наші послуги",
      intro: "Кожне авто і кожен диван — різні. Надішліть фото — ми підготуємо персональну пропозицію.",
      items: [
        { key: "interior", title: "Хімчистка салону", desc: "Ретельне очищення сидінь, килимів, пластику та скла — дбайливо до шкіри, тканини й алькантари." },
        { key: "exterior", title: "Догляд за кузовом", desc: "Делікатна ручна мийка, догляд за дисками та лаком для доглянутого блиску." },
        { key: "complete", title: "Комплексний детейлінг", desc: "Салон і кузов за один візит — для авто, яке має бути доглянутим повністю." },
        { key: "sofa", title: "Хімчистка диванів і меблів", desc: "Глибоке очищення диванів, матраців і м'яких меблів у вас вдома. Результат залежить від матеріалу та типу забруднення." },
      ],
      cta: "Дізнатись ціну", concept: "Ілюстративне фото", film: "Бренд-фільм",
    },
    portfolio: { title: "Реальні роботи. Реальний результат.", text: "До і після — фото з наших замовлень.", cta: "Усі роботи", real: "Реальна робота" },
    trust: { title: "Незалежні відгуки в Google.", text: "Читайте незалежні відгуки наших клієнтів безпосередньо в Google.", cta: "Відгуки в Google" },
    club: { cta: "Приєднатися до клубу" },
    academy: { cta: "Відкрити академію" },
  },
  en: {
    chapters: ["Introduction", "The Experience", "The Craft", "The Transformation", "Services", "Our Work", "Trust", "Club", "Academy", "Contact"],
    hero: {
      tagline: "Premium detailing. Right where you are.",
      copy: "Mobile car detailing and professional upholstery cleaning — we arrive with equipment, water and experience at your home or office. In Euskirchen, Bonn, Cologne and the surrounding area.",
      ctaPrice: "Request a price", ctaWhatsapp: "Contact on WhatsApp", scroll: "Discover",
    },
    experience: {
      title: "We come to you.",
      text: "Hand over the keys — we take care of the rest. Our mobile studio works right at your door while you carry on with your day.",
      points: ["Appointments around your schedule", "Full equipment on site", "No trip to the workshop"],
    },
    craft: {
      title: "Precision in every detail.",
      text: "Soft brushes, matched cleaning products and microfibre for every surface. We work section by section — carefully, gently on materials, with an eye for the details others miss.",
      points: ["Material-appropriate products", "Brushes and microfibre for delicate surfaces", "Careful final inspection"],
    },
    transformation: {
      title: "A result you can see.",
      text: "Cared-for paint, a fresh interior, clean lines. This is how your car should feel again — like day one, only better looked after.",
      note: "Scenes from the PUREGLOSS brand film. Real customer work is shown in the Our Work chapter.",
    },
    services: {
      title: "Our services",
      intro: "Every car and every sofa is different. Send us photos — we prepare a personal quote.",
      items: [
        { key: "interior", title: "Interior cleaning", desc: "Thorough cleaning of seats, carpets, plastics and glass — gentle on leather, fabric and Alcantara." },
        { key: "exterior", title: "Exterior care", desc: "Gentle hand wash, wheel and paint care for a well-kept shine." },
        { key: "complete", title: "Complete detailing", desc: "Inside and out in one appointment — for cars that should be cared for all round." },
        { key: "sofa", title: "Sofa & upholstery cleaning", desc: "Deep cleaning of sofas, mattresses and upholstered furniture at your home. Results depend on the material and type of soiling." },
      ],
      cta: "Request a price", concept: "Concept image", film: "Brand film",
    },
    portfolio: { title: "Real work. Real results.", text: "Before and after — photos from our jobs.", cta: "View all work", real: "Real customer work" },
    trust: { title: "Independent reviews on Google.", text: "Read independent reviews from our customers directly on Google.", cta: "Read reviews on Google" },
    club: { cta: "Join the Club" },
    academy: { cta: "Explore the Academy" },
  },
  pl: {
    chapters: ["Wprowadzenie", "Doświadczenie", "Rzemiosło", "Przemiana", "Usługi", "Realizacje", "Zaufanie", "Klub", "Akademia", "Kontakt"],
    hero: {
      tagline: "Premium detailing. U Ciebie.",
      copy: "Mobilny detailing samochodowy i profesjonalne pranie tapicerki — przyjeżdżamy ze sprzętem, wodą i doświadczeniem do Twojego domu lub biura. Euskirchen, Bonn, Kolonia i okolice.",
      ctaPrice: "Zapytaj o cenę", ctaWhatsapp: "Napisz na WhatsApp", scroll: "Odkryj",
    },
    experience: {
      title: "Przyjeżdżamy do Ciebie.",
      text: "Przekazujesz kluczyki — resztą zajmujemy się my. Nasze mobilne studio pracuje pod Twoimi drzwiami, a Ty spokojnie zajmujesz się swoim dniem.",
      points: ["Termin dopasowany do Ciebie", "Pełny sprzęt na miejscu", "Bez wizyty w warsztacie"],
    },
    craft: {
      title: "Precyzja w każdym detalu.",
      text: "Miękkie pędzle, dobrane środki i mikrofibra do każdej powierzchni. Pracujemy krok po kroku — starannie, delikatnie dla materiałów i z dbałością o szczegóły, które inni pomijają.",
      points: ["Środki dobrane do materiału", "Pędzle i mikrofibra do delikatnych powierzchni", "Staranna kontrola końcowa"],
    },
    transformation: {
      title: "Efekt, który widać.",
      text: "Zadbany lakier, świeże wnętrze, czyste linie. Tak Twój samochód powinien znów się prezentować — jak pierwszego dnia, tylko bardziej zadbany.",
      note: "Ujęcia z filmu marki PUREGLOSS. Prawdziwe realizacje dla klientów znajdziesz w rozdziale Realizacje.",
    },
    services: {
      title: "Nasze usługi",
      intro: "Każdy samochód i każda kanapa są inne. Wyślij zdjęcia — przygotujemy indywidualną ofertę.",
      items: [
        { key: "interior", title: "Czyszczenie wnętrza", desc: "Dokładne czyszczenie foteli, dywaników, plastików i szyb — delikatnie dla skóry, tkaniny i alcantary." },
        { key: "exterior", title: "Pielęgnacja nadwozia", desc: "Delikatne mycie ręczne, pielęgnacja felg i lakieru dla zadbanego połysku." },
        { key: "complete", title: "Kompleksowy detailing", desc: "Wnętrze i nadwozie podczas jednej wizyty — dla aut, które mają być zadbane w całości." },
        { key: "sofa", title: "Pranie kanap i tapicerki", desc: "Głębokie czyszczenie kanap, materacy i mebli tapicerowanych u Ciebie w domu. Efekt zależy od materiału i rodzaju zabrudzenia." },
      ],
      cta: "Zapytaj o cenę", concept: "Zdjęcie poglądowe", film: "Film marki",
    },
    portfolio: { title: "Prawdziwe realizacje. Prawdziwe efekty.", text: "Przed i po — zdjęcia z naszych zleceń.", cta: "Zobacz wszystkie realizacje", real: "Prawdziwa realizacja" },
    trust: { title: "Niezależne opinie w Google.", text: "Przeczytaj niezależne opinie naszych klientów bezpośrednio w Google.", cta: "Opinie w Google" },
    club: { cta: "Dołącz do klubu" },
    academy: { cta: "Poznaj akademię" },
  },
  ru: {
    chapters: ["Введение", "Опыт", "Мастерство", "Преображение", "Услуги", "Работы", "Доверие", "Клуб", "Академия", "Контакт"],
    hero: {
      tagline: "Премиум детейлинг. Прямо у вас.",
      copy: "Мобильный детейлинг автомобилей и профессиональная химчистка мягкой мебели — мы приезжаем с оборудованием, водой и опытом к вам домой или в офис. Euskirchen, Bonn, Köln и окрестности.",
      ctaPrice: "Узнать цену", ctaWhatsapp: "Написать в WhatsApp", scroll: "Далее",
    },
    experience: {
      title: "Мы приезжаем к вам.",
      text: "Вы передаёте ключи — остальное мы берём на себя. Наша мобильная студия работает прямо у вашего дома, пока вы занимаетесь своими делами.",
      points: ["Время по вашему графику", "Всё оборудование на месте", "Без поездок на мойку"],
    },
    craft: {
      title: "Точность в каждой детали.",
      text: "Мягкие щётки, подобранные средства и микрофибра для каждой поверхности. Мы работаем шаг за шагом — аккуратно, бережно к материалам и к деталям, которые другие не замечают.",
      points: ["Средства по типу материала", "Щётки и микрофибра для деликатных поверхностей", "Тщательная финальная проверка"],
    },
    transformation: {
      title: "Результат, который видно.",
      text: "Ухоженный лак, свежий салон, чистые линии. Таким ваш автомобиль должен ощущаться снова — как в первый день, только ухоженнее.",
      note: "Кадры из бренд-фильма PUREGLOSS. Реальные работы для клиентов — в разделе «Работы».",
    },
    services: {
      title: "Наши услуги",
      intro: "Каждый автомобиль и каждый диван — разные. Пришлите фото — мы подготовим персональное предложение.",
      items: [
        { key: "interior", title: "Химчистка салона", desc: "Тщательная очистка сидений, ковров, пластика и стёкол — бережно к коже, ткани и алькантаре." },
        { key: "exterior", title: "Уход за кузовом", desc: "Деликатная ручная мойка, уход за дисками и лаком для ухоженного блеска." },
        { key: "complete", title: "Комплексный детейлинг", desc: "Салон и кузов за один визит — для автомобиля, который должен быть ухожен полностью." },
        { key: "sofa", title: "Химчистка диванов и мебели", desc: "Глубокая очистка диванов, матрасов и мягкой мебели у вас дома. Результат зависит от материала и типа загрязнения." },
      ],
      cta: "Узнать цену", concept: "Иллюстративное фото", film: "Бренд-фильм",
    },
    portfolio: { title: "Реальные работы. Реальный результат.", text: "До и после — фото с наших заказов.", cta: "Все работы", real: "Реальная работа" },
    trust: { title: "Независимые отзывы в Google.", text: "Читайте независимые отзывы наших клиентов прямо в Google.", cta: "Отзывы в Google" },
    club: { cta: "Вступить в клуб" },
    academy: { cta: "Открыть академию" },
  },
};

export const homeCopy = (lang) => COPY[lang] || COPY.de;
